import store from "@/store";

const canAccessDoctorLocation = () =>
  store.getters.isAdmin || store.getters.isAssistant;

const doctorRoutes = [
  {
    path: "/doctor-location",
    name: "doctor-location",
    meta: {
      condition: canAccessDoctorLocation,
      redirectTo: { name: "home" },
    },
    component: () =>
      import(
        /* webpackChunkName: "doctor-location" */ "../components/doctor/DoctorLocationList.vue"
      ),
  },
];

export default doctorRoutes;
